import { Directive } from '@angular/core';

@Directive({
  selector: '[snDrawerTitle]',
  host: {
    class: 'sn-drawer__title',
  },
})
export class SnDrawerTitleDirective {}
